/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useContext } from 'react';
import styles from './style.module.scss';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Switch,
    TextField,
    Checkbox,
    Grid
} from '@material-ui/core';
import { PageItems, InventoryHeader } from './constant';
import { OverlayTrigger, Popover } from "react-bootstrap";
import EditIcon from '@material-ui/icons/Edit';
import ModalComponent from '../../components/AlertComponent/modal';
import { ProductLoader } from '../../components/Loader/skeletonLoader';
import { handleTypeNumber } from '../../utils/validation';
import {capitalizeOnlyFirstLetter} from '../../utils/commonFunctions';
import { Context as AuthContext } from '../../context/AuthContext';

const OrderTableData = ({
    selectedRows = [],
    selectRow,
    deselectRow, 
    selectAllRows,
    deSelectAllRows,
    ...props
}) => {
    const { state } = useContext(AuthContext);
    const loginData = state.userData;
    const tableHeader = InventoryHeader;
    const overlayPrice = useRef(null);
    const overlayQuantity = useRef(null);
    const [editQty, setEditQty] = useState(null);
    const [editPrice, setEditPrice] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalObj, setModalObj] = useState({
        msg: null,
        title: null
    });
    const [idx, setIndex] = useState(null);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState();


    useEffect(() => {
            document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    //function to handle modle click
    const handleClick = e => {
        if (overlayPrice && overlayPrice.current && (!overlayPrice.current.contains(e.target))) {
            let obj;
            if (props.showEditModal.price) {
                obj = 'price';
                props.cancelModal(obj);
            }
            else if (props.showEditModal.quantity) {
                obj = 'quantity'; props.cancelModal(obj);
            }
            setError(false);
            setErrorMsg(null);
        }
    };

    //function to fetch image path
    const getImagePath = (imgPath = '') => {
        if (imgPath.startsWith('http')) return imgPath;
        if (window.location.hostname === 'seller.gostor.com') {
            return `https://static.gostor.com/${imgPath}`
        }
        else {
            return `https://static.dev.gostor.com/${imgPath}`
        }
    }

    //function to check price and quantity validation
    const checkValidations = (type, item, index) => {
        if (type === 'price') {
            if ((!editPrice && parseInt(editPrice) !== 0)) {
                setError(true);
                setErrorMsg('Price is required.');
                return true
            }
            else if (parseInt(editPrice) === 0) {
                setError(true);
                setErrorMsg(`Enter valid price`);
                return true
            }
            else if (parseInt(editPrice) > item.mrp) {
                setError(true);
                setErrorMsg(`Listing price should not be greater than MRP(${item.mrp})`);
                return true
            }
            else {
                setError(false);
                setErrorMsg(null);
                props.updateInventoryFields({ price: parseInt(editPrice) }, item, type, index);
            }
        }
        else if (type === 'quantity') {
            if ((!editQty && parseInt(editQty) !== 0)) {
                setError(true);
                setErrorMsg('Quantity is required.');
                return true
            }
            else {
                setError(false);
                setErrorMsg(null);
                props.updateInventoryFields({ quantity: parseInt(editQty) }, item, type, index);
            }
        }
    }

    //function to handle input changes
    const handleInputChange = (type, e) => {
        type === 'price' ? setEditPrice(e.target.value) : setEditQty(e.target.value);
        setError(false);
        setErrorMsg(null);
    }

    const handleSelectAll = (event, allRows = []) => {
        event.target.checked ? selectAllRows(allRows) : deSelectAllRows();
    }

    //function to fetch table row data
    const getRowData = (column, value, item, index) => {
        if (column === 'product') {
            return <div >
                <img className={styles.prodImage} alt="Product Image" src={getImagePath(String(item.primaryImgPath))} />
            </div>
        }
        else if (column === 'action') {
            return <div className="row d-flex align-items-center justify-content-center">
                <Switch
                    checked={item.active === 1 ? true : false}
                    onChange={(e) => handleCheckBox(e, column, item)}
                    name="checkedA"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    color='primary'
                />
                {item.active ? 'Active' : 'Inactive'}
            </div>
        }
        else if ((column === 'price' || column === 'quantity')) {
            let refVal = column === 'price' ? overlayPrice : overlayQuantity;
            let showVal = column === 'price' ? props.showEditModal.price : props.showEditModal.quantity;
            return (
              <div
                ref={refVal}
                className="d-flex align-items-center justify-content-center"
              >
                <OverlayTrigger
                  container={refVal}
                  trigger="click"
                  placement="right"
                  show={showVal && idx === index}
                  overlay={
                    <Popover id="popover-basic">
                      <Popover.Content
                        style={{
                          paddingTop: "0.8rem",
                          paddingBottom: "0.8rem",
                        }}
                      >
                        <div>
                          <form noValidate autoComplete="off">
                            <TextField
                              type="number"
                              onKeyDown={(evt) => handleTypeNumber(evt)}
                              error={error}
                              helperText={errorMsg}
                              id="standard-basic"
                              value={column === "price" ? editPrice : editQty}
                              label={
                                column === "price"
                                  ? "Edit Price"
                                  : "Edit Quantity"
                              }
                              onChange={(e) => {
                                handleInputChange(column, e);
                              }}
                            />
                          </form>
                          <div className="d-flex mt-3 justify-content-between">
                            <Button
                              variant="contained"
                              color="primary"
                              disabled={error}
                              onClick={() =>
                                checkValidations(column, item, index)
                              }
                            >
                              Update
                            </Button>
                            <Button
                              variant="contained"
                              style={{
                                background: "white",
                                color: "grey",
                                outline: "none",
                              }}
                              disableElevation
                              onClick={() => props.cancelModal(column)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </Popover.Content>
                    </Popover>
                  }
                >
                  <div className="d-flex align-items-center">
                    <div>{value ? value : 0} </div>
                    {loginData?.seller_id !== 24346 && <div className="d-flex align-self-center">
                      <EditIcon
                        className={styles.editIcon}
                        onClick={() => {
                          
                                props.showModalFnc(column);
                                setIndex(index);
                                assignInputValues(column, value);
                          
                         
                        }}
                      />
                    </div>}
                  </div>
                </OverlayTrigger>
              </div>
            );
        }
        else if (column === 'category') {
            return value ? capitalizeOnlyFirstLetter(value) : value;
        }
        else {
            return value;
        }
    }

    //function to handle status checkbox
    const handleCheckBox = (e, type, item) => {
        let obj = { ...modalObj };
        if (e.target.checked) {
            obj.msg = `Are you sure to activate the product ${item.title}(${item.model}) for unit price ${item.price}?`;
            obj.btnTitle = 'Activate';
        }
        else {
            obj.msg = `Are you sure to deactivate the product ${item.title}?`;
            obj.btnTitle = 'Deactivate';
        }
        obj.item = item;
        setModalObj(obj);
        setShowModal(true);
    }

    //function to handle modal close
    const handleModalClose = () => {
        setShowModal(false);
    }

    //function to handle model submit
    const handleModalSubmit = () => {
        let obj = { ...modalObj };
        props.updateInventoryFields({ active: !obj.item.active }, obj.item, 'active', idx);
        setModalObj({});
        setShowModal(false);
    }

    //function to initialise price/quantity input
    const assignInputValues = (column, value) => {
        if (column === 'quantity') {
            setEditQty(value ? value : 0);
        }
        else {
            setEditPrice(value ? value : 0);
        }
    }

    return <React.Fragment >
        <div className={styles.orderWrapper}>
            {props.copySelectedFilters.model != null &&
                <Chip
                    label={props.copySelectedFilters.model}
                    onDelete={() => props.handleDelete(props.copySelectedFilters.model, 'model')}
                    className={`mb-1 mr-1 ${styles.chip}`}
                />}
            {props.copySelectedFilters.status != null &&
                <Chip
                    label={props.copySelectedFilters.status ? 'Active' : 'Inactive'}
                    onDelete={() => props.handleDelete(props.copySelectedFilters.status, 'status')}
                    className={`mb-1 mr-1 ${styles.chip}`}
                />}

            {props.copySelectedFilters.category && props.copySelectedFilters.category.map((item, index) => {
                return <Chip
                    key={index + item}
                    label={item}
                    onDelete={() => props.handleDelete(item, 'category')}
                    className={`mb-1 mr-1 ${styles.chip}`}
                />
            })}
            {props.copySelectedFilters.brand && props.copySelectedFilters.brand.map((item, index) => {
                return <Chip
                    key={index + item}
                    label={item}
                    onDelete={() => props.handleDelete(item, 'brand')}
                    className={`mb-1 mr-1 ${styles.chip}`}
                />
            })}
        </div>
        <div className={styles.tableConatiner}>
            {
                props.pageLoader ?
                    <Paper className={styles.loaderWrapper}>
                        <div id={styles.headerLoader}>
                        </div>
                        <div className="pl-4 pr-4">
                            <ProductLoader />
                        </div>
                    </Paper>
                    :
                    <Paper>
                        <TableContainer className={styles.parentWrapper}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {tableHeader.map((column, index) => (
                                            column.id === "checkbox" ? 
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    color="primary"
                                                    indeterminate={selectedRows.length > 0 && selectedRows.length < (props.reqObj.size * props.reqObj.page) - (props.reqObj.size - props.inventoryData.length)}
                                                    checked={selectedRows.length > 0 && selectedRows.length === (props.reqObj.size * props.reqObj.page) - (props.reqObj.size - props.inventoryData.length)}
                                                    onChange={(event) => handleSelectAll(event, props.inventoryData)}
                                                    inputProps={{
                                                        'aria-label': 'select all desserts',
                                                    }}
                                                />
                                            </TableCell> :
                                            <TableCell
                                                className={styles.tableBorder}
                                                key={index}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.inventoryData && props.inventoryData.length > 0 && props.inventoryData.map((order, index) => {
                                        return (
                                            <TableRow key={index} hover>
                                                {tableHeader.map((header) => {
                                                    const value = order[header.id];
                                                    if(header.id === "checkbox") {
                                                        const selectedProducts = selectedRows?.map(row => row.productId);
                                                        return (
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    color="primary"
                                                                    checked={selectedProducts.includes(order.productId)}
                                                                    onChange={(event) => {
                                                                        if(event.target.checked) {
                                                                            selectRow(order);
                                                                        } else {
                                                                            deselectRow(order);
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        'aria-label': 'select all desserts',
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        );
                                                    }
                                                    return (
                                                        <TableCell key={header.id} align={header.align} className={styles.tableBorder}>
                                                            {getRowData(header.id, value, order, index)}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                    {props.inventoryData && props.inventoryData.length === 0 &&
                                        <tr>
                                            <td colSpan="7">
                                                <div className="d-flex justify-content-center p-5 text-muted">
                                                    No data to display
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pl-3 pr-3 p-2">
                        <Grid container justify='space-between' >
                            <Grid item>
                            <div className="text-muted">
                            Showing {props.reqObj.page === 1 ? props.reqObj.page : props.reqObj.size * (props.reqObj.page - 1)} - 
                                {props.reqObj.page === 1 ? props.reqObj.size :  (props.inventoryData && props.inventoryData.length) === props.reqObj.size ? props.reqObj.size * props.reqObj.page : ((props.reqObj.size * props.reqObj.page) - (props.reqObj.size - props.inventoryData.length))} of {props.totalInventory} entries
                                <span className={styles.divider}></span>
                                <span>
                                    Rows per page
                                    <select
                                        className={styles.selectPadding}
                                        value={props.reqObj.size}
                                        onChange={(e) => props.setItemsPerPage(e.target.value)}>
                                        {
                                            PageItems.map((page, index) => {
                                                return <option key={index} value={page}>{page}</option>
                                            })
                                        }
                                    </select>
                                </span>
                            </div>
                            </Grid>
                            <Grid item>
                            <div className="">
                                <nav aria-label="..." style={{ top: 10 }}>
                                    <ul className="pagination mb-0">
                                        <li onClick={() => props.reqObj.page > 1 && props.totalPageCount != 0 ? props.handlePageChange('prev') : null} className={`page-item ${props.reqObj.page === 1 || props.totalPageCount === 0 ? "disabled" : null} `}>
                                            <button className={`${props.reqObj.page === 1 || props.totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} tabIndex="-1">
                                                Previous
                                            </button>
                                        </li>
                                        <li>
                                            <button className={`page-link ${styles.page}`} style={{ pointerEvents: 'none' }}>
                                                {props.reqObj.page}
                                            </button>
                                        </li>
                                        <li onClick={() => props.totalPageCount != props.reqObj.page && props.totalPageCount != 0 ? props.handlePageChange('Next') : ''} className={`page-item ${props.totalPageCount == props.page || props.totalPageCount === 0 ? "disabled" : null} `}>
                                            <button className={`${props.totalPageCount == props.reqObj.page || props.totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                            </Grid>
                            </Grid>
                        </div>
                    </Paper>
            }
        </div>
        <ModalComponent
            msg={modalObj.msg}
            btn1Text="Cancel"
            btn2Text={modalObj.btnTitle}
            show={showModal}
            handleClose={handleModalClose}
            handleBtn1={handleModalClose}
            handleBtn2={handleModalSubmit} />
    </React.Fragment>
}

const OrderTable = React.memo(OrderTableData);
export default OrderTable;
